import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";

function AlertComponent(props) {
    const { isOpen, onClose, title, message, otherMessage, actionName } = props;

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography>{message}</Typography>
                {otherMessage}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" id="alert/btnClose" onClick={onClose}>{actionName ? actionName : 'OK'}</Button>
            </DialogActions>
        </Dialog>
    )
}

AlertComponent.propTypes = {
    title: PropTypes.string,
    isOpen: PropTypes.bool,
    message: PropTypes.string,
    actionName: PropTypes.string,
    otherMessage: PropTypes.object,
    onClose: PropTypes.func,
}

export default AlertComponent;